import axios from 'axios';

const API_URL = 'https://67ukwvarr6.execute-api.us-east-1.amazonaws.com/prod/portco-metrics';

export const getMetricsForPortco = async (portcoId) => {
  try {
    const url = `${API_URL}?portcoId=${portcoId}`;
    const response = await axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}`
      },
    });

    console.log("PortcoMetricsAPIHelper :: getMetricsForPortco :: response :: " + response)
    if (response.status === 200) {
      return response.data;
    } else {
      console.error('Error:', response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};

export const deleteMetric = async (portco_metric_id) => {
  try {
    const url = `${API_URL}?portco_metric_id=${portco_metric_id}`;
    const response = await axios.delete(url, {
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}`  // uncomment if your API needs authorization
      },
    });

    console.log("PortcoMetricsAPIHelper :: deleteMetric :: response :: ", response)
    if (response.status === 200) { // usually, delete requests return a 204 No Content status code on success
      return response.status;  // you may want to return something else here, depending on your API
    } else {
      console.error('Error:', response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};

export const updateMetricsForPortco = async (metricsToUpdate) => {
  try {
    console.log("Rakesh Gidwani 11134");
    console.log(metricsToUpdate);
    const url = `${API_URL}`;
    const response = await axios.put(url, metricsToUpdate, {  // directly pass metricsToUpdate here
      headers: {
        'Content-Type': 'application/json',
        // 'Authorization': `Bearer ${token}`  // uncomment if your API needs authorization
      },
    });

    console.log("PortcoMetricsAPIHelper :: updateMetricsForPortco :: response :: ", response);
    if (response.status === 200) { 
      return response.data;  
    } else {
      console.error('Error:', response.status, response.statusText);
      return null;
    }
  } catch (error) {
    console.error('Error:', error);
    return null;
  }
};





